import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { useSite } from "../lib/SiteContext";

const Footer = () => {
  const { content } = useSite();
  const brand = content?.site?.brand_name || "Islands Escape";
  const suffix = content?.site?.brand_suffix || "Malta Charters";
  const c = content?.contact || {};

  return (
    <footer className="bg-primary text-white border-t border-white/10" data-testid="site-footer">
      <div className="container-x py-14 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif text-3xl md:text-4xl">{brand}</div>
            <div className="text-xs tracking-[0.3em] uppercase text-white/60 mt-2">{suffix}</div>
            <p className="text-white/70 mt-6 max-w-sm leading-relaxed">
              Private boat charters in Malta — half-day &amp; full-day, departing Sliema. Sun, sea, and the Maltese coast,
              just for your group.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-sand mb-4">Explore</div>
            <ul className="space-y-2 text-white/80">
              <li><a href="#charters" className="hover:text-sand">Charters</a></li>
              <li><a href="#fleet" className="hover:text-sand">The Boat</a></li>
              <li><a href="#destinations" className="hover:text-sand">Destinations</a></li>
              <li><a href="#faq" className="hover:text-sand">FAQ</a></li>
              <li><Link to="/book" className="hover:text-sand">Book online</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.25em] text-sand mb-4">Contact</div>
            <ul className="space-y-2 text-white/80">
              <li>{c.email}</li>
              <li>{c.phone}</li>
              <li>{c.address}</li>
            </ul>
            <div className="flex gap-3 mt-5">
              {c.instagram && (
                <a href={c.instagram} target="_blank" rel="noopener noreferrer" className="p-2 border border-white/30 hover:bg-white/10">
                  <Instagram size={16} />
                </a>
              )}
              {c.facebook && (
                <a href={c.facebook} target="_blank" rel="noopener noreferrer" className="p-2 border border-white/30 hover:bg-white/10">
                  <Facebook size={16} />
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} {brand} {suffix}. All rights reserved.</div>
          <Link to="/admin/login" className="hover:text-sand" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
